module.exports = __webpack_public_path__ + "img/产品体系@2x.7e1d5cef.png";